module.exports = require("./nds-NL.js");